import { render, staticRenderFns } from "./portfolioexcelDropdown.vue?vue&type=template&id=2b55ecb9&scoped=true&"
import script from "./portfolioexcelDropdown.vue?vue&type=script&lang=js&"
export * from "./portfolioexcelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./portfolioexcelDropdown.vue?vue&type=style&index=0&id=2b55ecb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55ecb9",
  null
  
)

export default component.exports